import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { TreeTableModule } from 'primeng/treetable';

import { HisCoreModule } from 'hisng';

import { AppComponent } from './app.component';

import { AppRoutesModule } from './app.routes';
import { ResStartpageComponent } from './res-startpage.component';
import { CommonCoreModule } from './fs/res/common/common-core.module';

@NgModule( {
    declarations: [
        AppComponent,
        ResStartpageComponent,
    ],
    imports: [
        AppRoutesModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        TreeTableModule,
        HisCoreModule,
        CommonCoreModule
    ],
    providers: [
    ],
    bootstrap: [AppComponent]
} )
export class AppModule { }
